'use client';
import { jsx as e, jsxs as y } from "react/jsx-runtime";
import { cn as I } from "@tameeni/shared-logic";
import { motion as s, LazyMotion as N, domAnimation as C, AnimatePresence as x, m as T, useMotionValue as h, useTransform as b, useAnimation as S, useInView as A } from "framer-motion";
import u, { useRef as D } from "react";
const $ = (t) => s(t), k = ({ children: t }) => /* @__PURE__ */ e(x, { children: t }), E = ({ children: t, className: i }) => {
  const n = u.useRef(null), a = A(n, { once: !0, amount: 0.5 });
  return /* @__PURE__ */ e("div", { className: i, ref: n, children: u.cloneElement(t, {
    animate: a ? "visible" : "hidden"
  }) });
}, c = ({
  children: t,
  useScroll: i = !1,
  variants: n,
  className: a,
  ...r
}) => {
  const o = $("div"), l = /* @__PURE__ */ e(
    o,
    {
      initial: "hidden",
      animate: "visible",
      exit: "hidden",
      variants: n,
      className: "h-full",
      ...r,
      children: t
    }
  );
  return /* @__PURE__ */ e(k, { children: i ? /* @__PURE__ */ e(E, { className: a, children: l }) : l });
}, P = ({ transition: t, ...i }) => /* @__PURE__ */ e(
  c,
  {
    variants: {
      hidden: { opacity: 0 },
      visible: { opacity: 1 }
    },
    transition: { duration: 0.5, ...t },
    ...i
  }
), V = ({ direction: t = "left", transition: i, ...n }) => /* @__PURE__ */ e(
  c,
  {
    variants: {
      hidden: { ...{
        left: { x: -50 },
        right: { x: 50 },
        up: { y: -50 },
        down: { y: 50 }
      }[t], opacity: 0 },
      visible: { x: 0, y: 0, opacity: 1 }
    },
    transition: { type: "spring", stiffness: 100, damping: 15 },
    ...n
  }
), B = ({ transition: t, ...i }) => /* @__PURE__ */ e(
  c,
  {
    variants: {
      hidden: { scale: 0.8 },
      visible: { scale: 1 }
    },
    transition: { type: "spring", stiffness: 260, damping: 20 },
    ...i
  }
), X = ({ transition: t, ...i }) => /* @__PURE__ */ e(
  c,
  {
    variants: {
      hidden: { rotate: -180, opacity: 0 },
      visible: { rotate: 0, opacity: 1 }
    },
    transition: { type: "spring", stiffness: 200, damping: 30 },
    ...i
  }
), O = ({ transition: t, ...i }) => /* @__PURE__ */ e(
  c,
  {
    variants: {
      hidden: { y: -50, opacity: 0 },
      visible: { y: 0, opacity: 1 }
    },
    transition: { type: "spring", stiffness: 400, damping: 10 },
    ...i
  }
), _ = ({ transition: t, ...i }) => /* @__PURE__ */ e(
  c,
  {
    variants: {
      hidden: { x: 0 },
      visible: { x: [0, -10, 10, -10, 10, 0] }
    },
    transition: { duration: 0.5, ...t },
    ...i
  }
), j = ({ transition: t, ...i }) => /* @__PURE__ */ e(
  c,
  {
    variants: {
      hidden: { scale: 1 },
      visible: { scale: [1, 1.05, 1] }
    },
    transition: { duration: 0.5, repeat: 1 / 0, repeatType: "reverse" },
    ...i
  }
), q = ({ transition: t, ...i }) => /* @__PURE__ */ e(
  c,
  {
    variants: {
      hidden: { rotateY: 90, opacity: 0 },
      visible: { rotateY: 0, opacity: 1 }
    },
    transition: { type: "spring", stiffness: 300, damping: 20 },
    ...i
  }
), G = ({ children: t, staggerDuration: i = 0.1, transition: n, ...a }) => {
  const r = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: i
      }
    }
  }, o = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { type: "spring", stiffness: 300, damping: 20 }
    }
  };
  return /* @__PURE__ */ e(c, { variants: r, ...a, children: u.Children.map(t, (l) => /* @__PURE__ */ e(s.div, { variants: o, children: l })) });
}, z = ({
  children: t,
  ...i
}) => /* @__PURE__ */ e(
  s.div,
  {
    whileHover: { scale: 1.05 },
    whileTap: { scale: 0.95 },
    transition: { type: "spring", stiffness: 400, damping: 17 },
    ...i,
    children: t
  }
), H = ({
  children: t,
  transition: i,
  ...n
}) => /* @__PURE__ */ e(
  s.div,
  {
    drag: !0,
    dragConstraints: { left: -100, right: 100, top: -100, bottom: 100 },
    whileDrag: { scale: 1.1 },
    dragTransition: { bounceStiffness: 600, bounceDamping: 10 },
    ...n,
    children: t
  }
), W = ({ text: t, transition: i, ...n }) => /* @__PURE__ */ e(
  c,
  {
    variants: {
      hidden: { opacity: 0 },
      visible: { opacity: 1, transition: { staggerChildren: 0.05 } }
    },
    ...n,
    children: t.split("").map((a, r) => /* @__PURE__ */ e(
      s.span,
      {
        variants: {
          hidden: { opacity: 0, y: 50 },
          visible: { opacity: 1, y: 0 }
        },
        children: a
      },
      `${a}-${r}`
    ))
  }
), J = ({
  children: t,
  pathLength: i = 1,
  ...n
}) => n.type === "svg" ? /* @__PURE__ */ e(
  s.svg,
  {
    initial: { pathLength: 0 },
    animate: { pathLength: i },
    transition: { duration: 2, ease: "easeInOut" },
    ...n,
    children: t
  }
) : /* @__PURE__ */ e(
  s.div,
  {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    transition: { duration: 2, ease: "easeInOut" },
    ...n,
    children: t
  }
), K = ({ text: t, delay: i = 50, repeat: n = !1, transition: a, ...r }) => {
  const o = {
    duration: i / 1e3,
    ...n && {
      repeat: n === !0 ? 1 / 0 : n,
      repeatDelay: 1
    }
  };
  return /* @__PURE__ */ e(
    c,
    {
      variants: {
        hidden: { width: "100%" },
        visible: {
          width: "100%"
        }
      },
      ...r,
      children: t.split("").map((l, d) => /* @__PURE__ */ e(
        s.span,
        {
          variants: {
            hidden: { opacity: 0, display: "none" },
            visible: {
              opacity: 1,
              display: "inline",
              transition: {
                ...o,
                delay: d * (i / 1e3)
              }
            }
          },
          children: l
        },
        `${l}-${d}`
      ))
    }
  );
}, Q = ({
  text: t = "please wait",
  className: i
}) => /* @__PURE__ */ y("div", { className: I("flex items-center", i), children: [
  /* @__PURE__ */ e("span", { children: t }),
  /* @__PURE__ */ e("div", { className: "flex space-x-1 ml-1", children: [0, 1, 2].map((n) => /* @__PURE__ */ e(
    s.span,
    {
      initial: { opacity: 0 },
      animate: { opacity: [0, 1, 0] },
      transition: {
        duration: 1.2,
        repeat: 1 / 0,
        delay: n * 0.4,
        ease: "easeInOut"
      },
      children: "."
    },
    n
  )) })
] }), U = ({
  transition: t,
  ...i
}) => /* @__PURE__ */ e(
  c,
  {
    variants: {
      hidden: { filter: "blur(10px)", opacity: 0 },
      visible: { filter: "blur(0px)", opacity: 1 }
    },
    transition: { duration: 0.5, ...t },
    ...i
  }
), Z = ({ front: t, back: i, transition: n, ...a }) => {
  const [r, o] = u.useState(!1);
  return /* @__PURE__ */ e(
    s.div,
    {
      className: "w-64 h-64 perspective-1000",
      onClick: () => o(!r),
      ...a,
      children: /* @__PURE__ */ y(
        s.div,
        {
          className: "w-full h-full relative transform-style-3d transition-all duration-500",
          animate: { rotateY: r ? 180 : 0 },
          children: [
            /* @__PURE__ */ e("div", { className: "absolute w-full h-full backface-hidden", children: t }),
            /* @__PURE__ */ e("div", { className: "absolute w-full h-full backface-hidden rotate-y-180", children: i })
          ]
        }
      )
    }
  );
}, tt = ({
  transition: t,
  ...i
}) => /* @__PURE__ */ e(
  s.div,
  {
    animate: {
      y: [0, -10, 0]
    },
    transition: {
      duration: 2,
      repeat: 1 / 0,
      repeatType: "reverse",
      ease: "easeInOut",
      ...t
    },
    ...i
  }
), it = ({ text: t, transition: i, ...n }) => /* @__PURE__ */ y(s.div, { className: "relative", ...n, children: [
  /* @__PURE__ */ e(
    s.div,
    {
      className: "absolute top-0 left-0 text-red-500",
      animate: {
        x: [-2, 2, -2],
        y: [2, -2, 2]
      },
      transition: {
        duration: 0.3,
        repeat: 1 / 0,
        repeatType: "reverse"
      },
      children: t
    }
  ),
  /* @__PURE__ */ e(
    s.div,
    {
      className: "absolute top-0 left-0 text-blue-500",
      animate: {
        x: [2, -2, 2],
        y: [-2, 2, -2]
      },
      transition: {
        duration: 0.3,
        repeat: 1 / 0,
        repeatType: "reverse",
        delay: 0.1
      },
      children: t
    }
  ),
  /* @__PURE__ */ e("div", { className: "relative", children: t })
] }), et = ({ children: t, isOpen: i, direction: n = "left", transition: a, ...r }) => {
  const o = {
    open: (l = 1e3) => ({
      clipPath: `circle(${l * 2 + 200}px at ${n === "left" ? "0 50%" : n === "right" ? "100% 50%" : n === "top" ? "50% 0" : "50% 100%"})`,
      transition: {
        type: "spring",
        stiffness: 20,
        restDelta: 2
      }
    }),
    closed: {
      clipPath: `circle(0px at ${n === "left" ? "0 50%" : n === "right" ? "100% 50%" : n === "top" ? "50% 0" : "50% 100%"})`,
      transition: {
        delay: 0.5,
        type: "spring",
        stiffness: 400,
        damping: 40
      }
    }
  };
  return /* @__PURE__ */ e(
    s.div,
    {
      initial: "closed",
      animate: i ? "open" : "closed",
      variants: o,
      ...r,
      children: t
    }
  );
}, nt = ({
  children: t,
  isOpen: i,
  ...n
}) => /* @__PURE__ */ e(N, { features: C, strict: !0, children: /* @__PURE__ */ e("div", { "aria-expanded": i, className: n.className, children: /* @__PURE__ */ e(x, { initial: !1, children: i && /* @__PURE__ */ e(
  T.div,
  {
    initial: "collapsed",
    animate: "open",
    exit: "collapsed",
    variants: {
      open: { height: "auto" },
      collapsed: { height: 0 }
    },
    transition: { duration: 0.8, ease: [0.04, 0.62, 0.23, 0.98] },
    children: t
  }
) }) }) }), at = ({
  children: t,
  ...i
}) => /* @__PURE__ */ e(
  s.div,
  {
    initial: { scale: 0 },
    animate: { scale: 1 },
    transition: {
      type: "spring",
      stiffness: 200,
      damping: 10,
      mass: 0.5,
      bounce: 0.8
    },
    ...i,
    children: t
  }
), st = ({
  children: t,
  ...i
}) => {
  const n = h(0), a = h(0), r = b(a, [-100, 100], [30, -30]), o = b(n, [-100, 100], [-30, 30]);
  return /* @__PURE__ */ e(
    s.div,
    {
      style: {
        perspective: 2e3,
        x: n,
        y: a,
        rotateX: r,
        rotateY: o,
        // transition: { damping: 20, stiffness: 300 },
        transition: ""
      },
      transition: { type: "spring", damping: 20, stiffness: 300 },
      drag: !0,
      dragElastic: 0.12,
      whileTap: { cursor: "grabbing" },
      ...i,
      children: /* @__PURE__ */ e(
        s.div,
        {
          style: {
            width: "100%",
            height: "100%",
            borderRadius: 30,
            backgroundColor: "rgba(255, 255, 255, 0.05)",
            border: "1px solid rgba(255, 255, 255, 0.1)",
            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)"
          },
          children: t
        }
      )
    }
  );
}, rt = ({
  children: t,
  ...i
}) => {
  const n = D(null), a = h(0), r = h(0), o = (d) => {
    var m;
    const p = (m = n.current) == null ? void 0 : m.getBoundingClientRect();
    if (p) {
      const f = p.left + p.width / 2, v = p.top + p.height / 2, w = Math.sqrt(
        Math.pow(d.clientX - f, 2) + Math.pow(d.clientY - v, 2)
      ), M = Math.max(p.width, p.height) / 2, g = Math.min(w / M, 1);
      a.set((d.clientX - f) * g * 0.1), r.set((d.clientY - v) * g * 0.1);
    }
  }, l = () => {
    a.set(0), r.set(0);
  };
  return /* @__PURE__ */ e(
    s.div,
    {
      ref: n,
      style: { x: a, y: r },
      onMouseMove: o,
      onMouseLeave: l,
      ...i,
      children: t
    }
  );
}, ot = ({ particleCount: t = 20, transition: i, ...n }) => {
  const a = S(), r = async () => {
    await a.start((o) => ({
      x: Math.random() * 200 - 100,
      y: Math.random() * 200 - 100,
      opacity: 0,
      scale: 0,
      transition: { duration: 0.5, delay: o * 0.02 }
    })), await a.start({ x: 0, y: 0, opacity: 1, scale: 1 });
  };
  return /* @__PURE__ */ y(s.div, { className: "relative", onClick: r, ...n, children: [
    [...Array(t)].map((o, l) => /* @__PURE__ */ e(
      s.div,
      {
        className: "absolute top-1/2 left-1/2 w-2 h-2 bg-blue-500 rounded-full",
        initial: { x: 0, y: 0, opacity: 1, scale: 1 },
        animate: a,
        custom: l
      },
      l
    )),
    n.children
  ] });
}, lt = ({ text: t, transition: i, ...n }) => {
  const a = t.split("");
  return /* @__PURE__ */ e(s.div, { ...n, children: a.map((r, o) => /* @__PURE__ */ e(
    s.span,
    {
      animate: {
        y: [0, -10, 0],
        transition: {
          duration: 0.5,
          repeat: 1 / 0,
          repeatType: "reverse",
          delay: o * 0.1
        }
      },
      style: { display: "inline-block" },
      children: r
    },
    `${r}-${o}`
  )) });
};
export {
  W as AnimatedText,
  U as BlurReveal,
  O as Bounce,
  nt as Collapse,
  H as Draggable,
  J as DrawSVG,
  et as Drawer,
  at as ElasticBounce,
  P as FadeIn,
  q as Flip,
  Z as FlipCard,
  tt as FloatingAnimation,
  it as GlitchEffect,
  z as InteractiveScale,
  st as LiquidMotion,
  Q as LoadingDots,
  rt as MagneticEffect,
  ot as ParticleExplosion,
  j as Pulse,
  X as Rotate,
  B as Scale,
  _ as Shake,
  V as SlideIn,
  G as StaggerChildren,
  K as Typewriter,
  lt as WavyText
};
